import $ from 'jquery';

export default class StaticAddresses {
  constructor(section) {
    this.$el = $(section.el);

    this._bindEvents();
  }

  _bindEvents() {
    $('.delete-address', this.$el).on('click', (e) => this.deleteAddress(e));
    $('.edit-address', this.$el).on('click', (e) => this.editAddress(e));
    $('.cancel-edit', this.$el).on('click', (e) => this.cancelEditing(e));
    $('.toggle-new-address', this.$el).on('click', () => this.toggleNewAddress());
    $('.select-wrapper select', this.$el).on('change', (e) => this.updateSelectedText(e, false));
  }

  prepareAddresses() {
    new Shopify.CountryProvinceSelector('address-country', 'address-province', {
      hideElement: 'address-province-container',
    });

    const addresses = $('.customer-address', this.$el);
    if (addresses.length) {
      for (let i = 0; i < addresses.length; i++) {
        const address = addresses[i];
        const addressID = $(address).data('address-id');

        new Shopify.CountryProvinceSelector(`address-country-${addressID}`, `address-province-${addressID}`, {
          hideElement: `address-province-container-${addressID}`,
        });
      }
    }

    const selectableOptions = $('.select-wrapper select', this.$el);

    for (let i = 0; i < selectableOptions.length; i++) {
      this.updateSelectedText(null, selectableOptions[i]);
    }
  }

  updateSelectedText(e, select) {
    const text = e ? $(e.target) : $(select);
    const selectedValue = text.find('option:selected').text();

    if (selectedValue !== '') {
      text.prev('.selected-text').text(selectedValue);
    }

    if (text.attr('name') === 'address[country]') {
      let addressID = $(text).attr('id').split('address-country-')[1];
      addressID = addressID ? `#address-province-${addressID}` : '.new-address-province';

      this.updateSelectedText(null, $(addressID));
    }
  }

  deleteAddress(e) {
    const addressID = $(e.target).parents('[data-address-id]').data('address-id');
    Shopify.CustomerAddress.destroy(addressID);
  }

  editAddress(e) {
    const addressID = $(e.target).parents('[data-address-id]').data('address-id');
    $(`.customer-address[data-address-id='${addressID}']`).addClass('editing');
    $(`.customer-address-edit-form[data-address-id='${addressID}']`).addClass('show');
    this.prepareAddresses();
  }

  cancelEditing(e) {
    const addressID = $(e.target).parents('[data-address-id]').data('address-id');
    $(`.customer-address[data-address-id='${addressID}']`).removeClass('editing');
    $(`.customer-address-edit-form[data-address-id='${addressID}']`).removeClass('show');
  }

  toggleNewAddress() {
    $('.add-new-address', this.$el).toggle();
    $('.customer-new-address', this.$el).toggleClass('show');
  }

  onSectionUnload() {
    $('.delete-address', this.$el).off('click');
    $('.edit-address', this.$el).off('click');
    $('.cancel-edit', this.$el).off('click');
    $('.toggle-new-address', this.$el).off('click');
    $('.select-wrapper select', this.$el).off('change');
  }
}
